module.exports = __webpack_public_path__ + "img/www.yell.com.bc41fce3.png";